// Directionally-aware header.
// Hides on scroll-down, reveals on scroll-up. Motion is a CSS transition on .header (see sw-styles.css).

(function () {
  if (window.__swHeaderFx) return;
  window.__swHeaderFx = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var header = document.querySelector('.header');
    if (!header) return;

    var HIDE_THRESHOLD  = 10;   // px downward accumulation before hiding
    var SHOW_THRESHOLD  = 6;    // px upward accumulation before revealing
    var ALWAYS_SHOW_TOP = 80;   // always visible within this many px of the top

    var lastY       = window.scrollY;
    var accumulated = 0;
    var hidden      = false;

    function reveal() {
      if (!hidden) return;
      hidden = false;
      header.classList.remove('is-hidden');
      // Reveal: drop the transparent hold. If past the top, is-solid is set, so the
      // header fades to solid while sliding down; at the top it stays transparent.
      header.classList.remove('sw-keep-transparent');
    }

    var cartDot = document.querySelector('.header__cart-dot');
    function cartHasItems() {
      return cartDot && cartDot.classList.contains('is-visible');
    }

    function conceal() {
      if (hidden) return;
      if (cartHasItems()) return;
      hidden = true;
      // If still transparent, hold it transparent while sliding up so theme.js's
      // is-solid (IntersectionObserver) can't flash the solid background mid-hide.
      if (!header.classList.contains('is-solid')) header.classList.add('sw-keep-transparent');
      header.classList.add('is-hidden');
    }

    document.addEventListener('cart:change', function (e) {
      var count = e.detail && e.detail.cart && e.detail.cart.item_count;
      if (count > 0) reveal();
    });

    // On touch, inertia keeps firing scroll events after the finger lifts.
    // Reset the accumulator on each new touch so upward swipes reveal immediately.
    window.addEventListener('touchstart', function () {
      accumulated = 0;
      lastY = Math.max(0, window.scrollY);
    }, { passive: true });

    window.addEventListener('scroll', function () {
      var y     = Math.max(0, window.scrollY);
      var delta = y - lastY;
      lastY     = y;

      if (y < ALWAYS_SHOW_TOP) {
        reveal();
        accumulated = 0;
        return;
      }

      accumulated += delta;

      if (accumulated > HIDE_THRESHOLD) {
        conceal();
        accumulated = 0;
      } else if (accumulated < -SHOW_THRESHOLD) {
        reveal();
        accumulated = 0;
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
